import React from 'react';
import type { RouteObject } from 'react-router-dom';
import LoginPage from './LoginPage';
import PasswordResetPage from './PasswordResetPage';

const loginRoutes: RouteObject[] = [
  {
    path: '/login',
    element: <LoginPage />,
    handle: {
      documentTitle: 'Login',
      crumb: () => ({ label: 'Login' })
    },
  },
  {
    path: '/login/password/reset',
    element: <PasswordResetPage />,
    handle: {
      documentTitle: 'Reset Password',
      crumb: () => ({ label: 'Reset Password' })
    },
  },
];

export default loginRoutes;
